import { render, staticRenderFns } from "./barGain.vue?vue&type=template&id=3a1e1d1f&scoped=true&"
import script from "./barGain.vue?vue&type=script&lang=js&"
export * from "./barGain.vue?vue&type=script&lang=js&"
import style0 from "./barGain.vue?vue&type=style&index=0&id=3a1e1d1f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1e1d1f",
  null
  
)

export default component.exports